export const groupings = {
    recommendation: "recommendation",
    catalog: "catalog",
}